import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import { concat } from 'lodash'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading module routes
 * -----------------------------------------------------------------------------------------------------------
 */
import homeRouter from '@/components/home/router'
import accountRouter from '@/components/account/router'
import categoryBlogRouter from '@/components/category-blogs/router'
import categoryItemRouter from '@/components/category-items/router'
import blogRouter from '@/components/blogs/router'
import contactRouter from '@/components/contacts/router'
import settingRouter from '@/components/settings/router'
import userRouter from '@/components/users/router'
import pageRouter from '@/components/pages/router'
import configmenuRouter from '@/components/configmenus/router'
import projectRouter from '@/components/projects/router'
import itemRouter from '@/components/items/router'
import logRouter from '@/components/logs/router'

Vue.use(Router)

Vue.use(Meta, {
  keyName: 'metaInfo', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-vue-meta', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-vue-meta-server-rendered', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'vmid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: concat(
    homeRouter,
    accountRouter,
    categoryBlogRouter,
    categoryItemRouter,
    blogRouter,
    contactRouter,
    settingRouter,
    userRouter,

    pageRouter,
    configmenuRouter,
    projectRouter,
    itemRouter,
    logRouter
  )
})



// WEBPACK FOOTER //
// ./src/router/index.js